module.exports = __webpack_public_path__ + "static/media/como.6b7d9465.png";